import { PopUpInformative } from 'components/molecules/Popup-informative/Popup-informative';
import { maskEmail } from 'utils/mask.utils';
import './Popup-email-send.scss';

export interface IPopupEmailSend {
  closePopUp: () => void;
  email: string;
  /** When set, replaces the default masked-email subtitle (e.g. phone contact). */
  customSubtitle?: string;
}

export const PopupEmailSend = (props: IPopupEmailSend) => {
  const subtitle =
    props.customSubtitle ??
    `Revise su correo electrónico </br> ${maskEmail(props.email, 1)}`;
  return (
    <PopUpInformative
      title="¡Enviado con éxito!"
      type="successful"
      closePopUp={props.closePopUp}
      subtitle={subtitle}
      text=" Deberá haber recibido un enlace para restablecer su contraseña."
    ></PopUpInformative>
  );
};
